import type { FaireProductEntity } from "../../entity_types/product";

export const p_esqrwdngp5: FaireProductEntity = {
  token: "p_esqrwdngp5",
  type: "product",
  name: "Evil Eye Bead Station Chain Necklace",
  brandToken: "b_c3xmn96nkh",
  brandName: "Sensibling Corp.",
  imageUrl:
    "https://cdn.faire.com/fastly/d38d726fc7a6fdd14a19b3a098b1a4af7ae00dd8c04f27d8a41e6b72049131cf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/38bc4d1cc6c25416197072ca642a06a34140762788f4697735a348a291b11409.jpeg",
    "https://cdn.faire.com/fastly/23959b9857a4f49256d9a3111c76c823cf8c3a70fb479b302097cb5a496683fc.jpeg",
    "https://cdn.faire.com/fastly/f2a082e48c9954ca0ed7a8e3f67ce3162678070da1e06deb8b2f3021b88c24c4.jpeg",
    "https://cdn.faire.com/fastly/eb99809cfffc23b577264ca01c21463126bc6c9336e907effa07620f0dd5defa.jpeg",
    "https://cdn.faire.com/fastly/9dfe51edbe06a85b5c0e88fe94405ff07a82db7fcdae55aee33febeb312e4cc5.jpeg",
    "https://cdn.faire.com/fastly/d3ee7ac2acab657d3720ef926b2ea64b243d68ce5a28efd06b60ce74d654e378.jpeg",
    "https://cdn.faire.com/fastly/b4f1cc99f0500eb51d235538488b9588d5c6d2fbb9bc29e54ac24c9bc7c087bf.jpeg",
  ],
  priceDollars: 6.1,
  description:
    'Necklace Size : 15" + 3" L\r\nDecor Size : 0.15" L\r\nAdd meaningful style to your jewelry collection with this evil eye charm chain necklace featuring evenly spaced symbolic accents. A delicate statement piece perfect for layering or wearing solo for everyday elegance and subtle spiritual charm.\nLead and Nickel Compliant\n',
  tags: [],
  msrpDollars: 12.19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:56.466Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
